import React from 'react';
import formatInstructionsByDataType from '../../data/instructions';

export function getInstructionsConfig(dataType, platform, lang, {appName, dataDescription, logoURL, showSimpleInstructions, collectionMode}) {

  const customVideoIOS = {
    data_type: 'custom_video',
    data_type_description: appName,
    logo: logoURL,
    summary_html: '',
    summary_no_video_html: `<p>Retro jobs are simple, quick and fun. Read the steps below and then, when you're ready, hit record and scroll through your ${dataDescription}.</p>`,
    steps: [
      {
        step_type: 'numbered_step',
        number: '1',
        description_html: `<p>Open the <b>${appName}</b> app and log in before starting to record.</p>`
      },
      {
        step_type: 'numbered_step',
        number: '2',
        description_html: `<p>Find your <b>${dataDescription}</b> and then start screen recording.</p>`
      },
      {
        step_type: 'numbered_step',
        number: '3',
        description_html: '<p>Scroll through until you reach the end of the list before you stop recording.</p>'
      }
    ],
    capture_type: 'video',
    use_in_app_screen_recorder: false,
  };

  const customVideoAndroid = {
    data_type: 'custom_video',
    data_type_description: appName,
    logo: logoURL,
    summary_html: '',
    summary_no_video_html: `<p>Retro jobs are simple, quick and fun. Read the steps below and then, when you're ready, hit record and scroll through your ${dataDescription}.</p>`,
    steps: [
      {
        step_type: 'numbered_step',
        number: '1',
        description_html: `<p>Open the <b>${appName}</b> app and log in before starting to record.</p>`
      },
      {
        step_type: 'numbered_step',
        number: '2',
        description_html: `<p>Find your <b>${dataDescription}</b>, then switch back to the MSR app to start screen recording.</p>`
      },
      {
        step_type: 'numbered_step',
        number: '3',
        description_html: '<p>Scroll through until you reach the end of the list before you return to the MSR app and stop recording.</p>'
      }
    ],
    capture_type: 'video',
    use_in_app_screen_recorder: true,
  };

  const customFile = {
    data_type: 'custom_file',
    data_type_description: appName,
    logo: logoURL,
    summary_html: '',
    summary_no_video_html: `<p>Retro jobs are simple, quick and fun. Read the steps below and then, when you're ready, find the file with your ${dataDescription}.</p>`,
    steps: [
      {
        step_type: 'numbered_step',
        number: '1',
        description_html: `<p>Tap on the button below to open the file browser.</p>`
      },
      {
        step_type: 'numbered_step',
        number: '2',
        description_html: `<p>Find the file with your <b>${dataDescription}</b> and select it.</p>`
      },
      {
        step_type: 'numbered_step',
        number: '3',
        description_html: '<p>Follow the on-screen prompts to complete the upload.</p>'
      }
    ],
    capture_type: 'file',
    use_in_app_screen_recorder: false,
  };

  const customImage = {
    data_type: 'custom_image',
    data_type_description: appName,
    logo: logoURL,
    summary_html: '',
    summary_no_video_html: `<p>Retro jobs are simple, quick and fun. Read the steps below and then, when you're ready, find the image of your ${dataDescription}.</p>`,
    steps: [
      {
        step_type: 'numbered_step',
        number: '1',
        description_html: `<p>Tap on the button below to open the image browser.</p>`
      },
      {
        step_type: 'numbered_step',
        number: '2',
        description_html: `<p>Find the image with your <b>${dataDescription}</b> and select it.</p>`
      },
      {
        step_type: 'numbered_step',
        number: '3',
        description_html: '<p>Follow the on-screen prompts to complete the upload.</p>'
      }
    ],
    capture_type: 'image',
    use_in_app_screen_recorder: false,
  };

  const customInstructions = {
    'ios': {
      'custom_video': customVideoIOS,
    },
    'android': {
      'custom_video': customVideoAndroid,
    },
    'generic': {
      'custom_file': customFile,
      'custom_image': customImage,
      // 'google_takeout_data_upload': customFile,
    }
  }

  // get a list (without repeats) of the custom data types from the object above
  const customDataTypes = [...new Set([
    ...Object.keys(customInstructions['ios']),
    ...Object.keys(customInstructions['android']),
    ...Object.keys(customInstructions['generic']),
  ])];

  if (customDataTypes.includes(dataType)) {
    if (customInstructions[platform]) {
      if (customInstructions[platform][dataType]) {
        return customInstructions[platform][dataType];
      }
    } 
    return customInstructions['generic'][dataType] ?? null;
  }
  const packagedInstructions = formatInstructionsByDataType(dataType, platform, lang, showSimpleInstructions);

  // Per-job collection mode. A data_type's config may declare an `upload_mode`
  // block (see chatgpt.js) with the fields to use for a manual file upload. When
  // the job's screen_capture sets collection_mode: 'upload', merge that block over
  // the resolved config so the standard steps + uploader render instead of the
  // default flow (e.g. an extension-pull component). Fully config-driven: this
  // stays a generic resolver, and any config without `upload_mode` is untouched.
  if (collectionMode === 'upload' && packagedInstructions?.upload_mode) {
    return {
      ...packagedInstructions,
      ...packagedInstructions.upload_mode,
    };
  }

  return packagedInstructions;
}
